import { z } from "zod";

export const buscaGlobalSchema = z.object({
  termo: z.string().trim().min(2).max(80),
  /** Busca em todas as organizações em que o usuário é membro ativo, não só na ativa. */
  todas: z.boolean().default(false),
});
export type BuscaGlobalInput = z.infer<typeof buscaGlobalSchema>;

export const GRUPOS_DE_BUSCA = [
  "pacientes",
  "pedidos",
  "pedidosRecebidos",
  "cadastros",
  "equipe",
  "servicos",
  "materiais",
  "equipamentos",
  "insumos",
] as const;
export type GrupoDeBusca = (typeof GRUPOS_DE_BUSCA)[number];

export type ResultadoDeBusca = {
  grupo: GrupoDeBusca;
  id: string;
  titulo: string;
  detalhe: string | null;
  organizationId: string;
  organizationName: string;
  /** Rota que abre o item (com `?abrir=` quando a tela sabe abrir um item específico). */
  destino: string;
};
